import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\UpdateItemStockListControlleur::__invoke
* @see app/Http/Controllers/Item/UpdateItemStockListControlleur.php
* @route '/api/item-stock-list-update/{item}'
*/
const UpdateItemStockListControlleur = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateItemStockListControlleur.url(args, options),
    method: 'put',
})

UpdateItemStockListControlleur.definition = {
    methods: ["put"],
    url: '/api/item-stock-list-update/{item}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Item\UpdateItemStockListControlleur::__invoke
* @see app/Http/Controllers/Item/UpdateItemStockListControlleur.php
* @route '/api/item-stock-list-update/{item}'
*/
UpdateItemStockListControlleur.url = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { item: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { item: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            item: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        item: typeof args.item === 'object'
        ? args.item.id
        : args.item,
    }

    return UpdateItemStockListControlleur.definition.url
            .replace('{item}', parsedArgs.item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\UpdateItemStockListControlleur::__invoke
* @see app/Http/Controllers/Item/UpdateItemStockListControlleur.php
* @route '/api/item-stock-list-update/{item}'
*/
UpdateItemStockListControlleur.put = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateItemStockListControlleur.url(args, options),
    method: 'put',
})

export default UpdateItemStockListControlleur